












import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class AbcLoader extends Vue {
    @Prop({ default: 45 }) size!: number;
    @Prop({ default: 'locale' }) scope!: "normal" | "absolute" | "fixed";
    scopes = {
        normal: "",
        absolute: "w-full h-full flex absolute inset-0 bg-white bg-opacity-50 z-50",
        fixed: "w-screen h-screen flex fixed inset-0 bg-white bg-opacity-50 z-50 inset-0"
    }
}
